import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(() => ({
  mainFileGridContainer: {
    height: '100%',
    paddingLeft: '20px'
  },
  box: {
    padding: '10px 20px',
    background: `transparent linear-gradient(90deg, #8F34EA1A 0%, #2B4BDA1A 100%) 0% 0% no-repeat padding-box`,
    borderRadius: '8px'
  },
  DocExplorerMainTxt: {
    fontFamily: 'Satoshi !important',
    fontSize: '18px !important',
    fontWeight: '400 !important',
    color: '#373737 !important'
  }
}));

const DocExplorerFiles = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <div className={classes.mainFileGridContainer}>
        <Box className={classes.box}>
          <Typography className={classes.DocExplorerMainTxt}>
            {t('docExplorer.documents')}
          </Typography>
        </Box>
      </div>
    </>
  );
};

export default DocExplorerFiles;
